import Page, { getServerSideProps } from 'pages/[lang]/features';

export default Page;

export { getServerSideProps };
